import { IconUnpaid } from '@justeattakeaway/pie-icons-react';
import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import PIETag, { ETagsColorType } from '@src/shared/components/PIETag';
import React, { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { globalStyles } from 'snacks-design-system';

const { xdsSpacingB } = globalStyles;

const TagUnpaid = () => {
  const { t } = useTranslation();
  return (
    <PIETag modStrong={true} mode={ETagsColorType.Brand05}>
      <PIEComponentUtil paddingX={xdsSpacingB}>
        <IconUnpaid size="xs" /> {t('order.payment_UNPAID')}
      </PIEComponentUtil>
    </PIETag>
  );
};

export default TagUnpaid;
